import z, { ZodType } from 'zod';

export const PagedRequest = <T extends ZodType<any>>(ItemType: T) =>
    z.object({
        skip: z.number().nullish(),
        limit: z.number().nullish(),
        totalItemCount: z.number().nullish(),
        items: z.array(ItemType),
    });

export type PagedRequest = z.infer<ReturnType<typeof PagedRequest>>;
